
import { observer, React, toJS, theme } from "aaa";
import { Z_INDEX_DEBUG_OVERLAY } from "muiTheme";
import { debugStore } from "stores/DebugStore";

function stringifyCircular(obj: any) {
    return JSON.stringify(obj, function (k, v) { return k && v && typeof v !== "number" ? (Array.isArray(v) ? "[object Array]" : "" + v) : v; });
}

export const DebugConsole = observer(() => {
    const entries = debugStore.entries.map((entry, index) => {
        const js = toJS(entry);
        const params = js.optionalParams && js.optionalParams.length > 0 ?
            js.optionalParams.map((param: any) => {
                return stringifyCircular(param[0]);
            }).join(", ") :
            "";
        return <div style={{ whiteSpace: "nowrap" }} key={entry.message + index}>{entry.message} {params}</div>;
    });

    return (
        <div
            style={{
                position: "absolute",
                bottom: 0,
                background: "#fdd",
                width: "100%",
                height: "80%",
                pointerEvents: "none",
                fontSize: 14,
                display: "flex",
                flexDirection: "column-reverse",
                overflow: "hidden",
                padding: 4,
                boxSizing: "border-box"
            }}
        >
            {entries}
        </div>
    );
});

export const DebugOverlay = observer(() => {
    return (
        <div
            style={{
                position: "fixed", width: "100%", maxWidth: theme.MAX_APP_WIDTH,
                height: "100%", zIndex: Z_INDEX_DEBUG_OVERLAY, opacity: 0.8, pointerEvents: "none"
            }}
        >
            <div style={{ display: "flex", alignItems: "center", position: "absolute", width: "100%", top: 8 }}>
                <div style={{ flex: 1, pointerEvents: "none" }} />
                <div
                    style={{ background: "red", padding: 20, cursor: "pointer", pointerEvents: "all", borderRadius: 30 }}
                    onClick={() => { debugStore.showConsole = !debugStore.showConsole; }}
                    role="button"
                >
                    SHOW CONSOLE
                </div>
                <div style={{ flex: 1, pointerEvents: "none" }} />
            </div>

            {debugStore.showConsole && <DebugConsole />}
        </div>
    );
});



// WEBPACK FOOTER //
// ./src/components/common/DebugConsole.tsx